module.exports = __webpack_public_path__ + "img/1.d83a04b5.svg";